import { createImageRenderer, standardTileName } from './imageRenderer.jsx'

// Martin Persson tile set, vendored from m4tx/riichi-hand-rs (tilesets/MartinPersson).
// Free for personal/commercial use with a link to https://www.martinpersson.org.
// PNG art: 82x128.
export const martinPerssonRenderer = createImageRenderer({
  basePath: '/tiles/martinpersson',
  fileFor: standardTileName,
  aspect: 128 / 82,
  ext: 'png',
})

export default martinPerssonRenderer
